import { Banner, Col, Row, Typography } from 'darrius';

import { HowMuchData } from '../../../data/home/homeData';

import styles from './HowMuch.module.scss';

export const HowMuch = () => {
  return (
    <Banner as="section" className={styles['how-much']}>
      <Col className="col-sm-12">
        <Row className="middle-sm space-bottom space-between">
          <Col className="col-sm-12 col-md-2 hide-mobile">
            <img
              src={`${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/icons/partner-money-package.svg`}
              alt="Icone pacote de moedas"
            />
          </Col>
          <Col className="col-sm-12 col-md-5">
            <Typography.Title size="3xl">{HowMuchData.title}</Typography.Title>

            <Typography.Subtitle size="m">
              <span>{HowMuchData.descriptionFirstPart} </span>
              {HowMuchData.descriptionSecondPart}
            </Typography.Subtitle>
          </Col>
          <Col className="col-sm-12 col-md-5 center-sm">
            <img
              src={`${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/partner-how-much.svg`}
              alt="Icone quanto custa"
            />
          </Col>
        </Row>
      </Col>
    </Banner>
  );
};
